import type { Discipline } from '@structural-climbing/validation'

/**
 * Trim a grade-ordered chart series to the span that has data. Lead runs over
 * all 27 French grades, and a gym sets perhaps a dozen of them, so an untrimmed
 * chart is mostly empty rows from 4 to 9c. Grades inside the span keep their
 * zero so a gap in the wall still shows. Boulder scales are short and gym
 * defined, so they are always shown in full.
 */
export function trimToUsedGrades<T>(
  rows: T[],
  hasData: (row: T) => boolean,
  discipline: Discipline,
): T[] {
  if (discipline !== 'lead') return rows
  const first = rows.findIndex(hasData)
  if (first === -1) return []
  let last = rows.length - 1
  while (last > first && !hasData(rows[last])) last--
  return rows.slice(first, last + 1)
}
